import { DigitalMemberTag, UIIconButton } from "common/components";
import { useElementIsLoaded } from "common/utilities";
import { useTranslate } from "common/utilities/useTranslate";
import { StyledLandingText } from "domains/landing/components/StyledLandingText";
import { StyledLandingTitle } from "domains/landing/components/StyledLandingTitle";
import CreateImage from "domains/landing/create/create-image.png";
import {
  SlidingContainer,
  StyledImage,
  StyledInfoContainer,
  StyledSectionContainer,
} from "domains/landing/create/shared";

export const CreateSection = () => {
  const { elementRef, isLoaded } = useElementIsLoaded(0.5);
  const translate = useTranslate();

  return (
    <StyledSectionContainer ref={elementRef}>
      <StyledInfoContainer>
        <SlidingContainer $isLeft $isLoaded={isLoaded}>
          <DigitalMemberTag trackPage="Landing" />
          <StyledLandingTitle>{translate("app.create.title")}</StyledLandingTitle>
          <StyledLandingText>{translate("app.create.promo_text1")}</StyledLandingText>
          <UIIconButton
            as="a"
            href="https://www.youtube.com/embed/ww5WcMWOLFI"
            icon="play"
            target="_blank"
            variant="outlined"
          >
            {translate("app.discover.curatedBanner.button")}
          </UIIconButton>
        </SlidingContainer>
      </StyledInfoContainer>
      <StyledInfoContainer>
        <SlidingContainer $isLoaded={isLoaded}>
          <StyledImage src={CreateImage} alt={translate("app.topic.insight_briefing")} />
        </SlidingContainer>
      </StyledInfoContainer>
    </StyledSectionContainer>
  );
};
